import { createAsyncThunk } from "@reduxjs/toolkit";
import { axios } from "@redux/axios";
import { toast } from "react-toastify";

const API_URL = "/v1/referrers";


export const FetchReferrers = createAsyncThunk(
  "referrers/fetchAll",
  async (data: any = {}, { rejectWithValue }) => {
    try {
      console.log(data)
      const res = await axios.get("/v1/referrers", {
        headers: { "Content-Type": "application/json" },
        params: data,
      });

      if (res?.data?.error) return rejectWithValue(res?.data?.error);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

  

export const CreateReferrer = createAsyncThunk(
  "referrers/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.post(API_URL, data);
      if (res?.data?.error) return rejectWithValue(res?.data?.error);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const CreateReferrerNew = createAsyncThunk(
  "referrers/create/new",
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${API_URL}/new` ,data);
      if (res?.data?.error) return rejectWithValue(res?.data?.error);
      toast.success("New referrer created successfully!");
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const FetchReferrerTransactions = createAsyncThunk(
  "referrers/fetchTransactions",
  async (
    { referrerId, pageSize = 10, pageNumber = 1, ...filters }: 
    { referrerId: string; pageSize?: number; pageNumber?: number; [key: string]: any },
    { rejectWithValue }
  ) => {
    try {
      const res = await axios.get(`${API_URL}/${referrerId}/transactions`, {
        params: {
          pageSize,
          pageNumber, // or 'page' depending on your API
          ...filters
        }
      });
      
      if (res?.data?.error) return rejectWithValue(res?.data?.error);
      
      return {
        list: res.data.list, // Contains both referrer info and transactions
        total: res.data.total,
        pageSize: res.data.pageSize,
        pageNumber: res.data.pageNumber,
        totalPages: res.data.totalPages
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const GetReferrrerData = createAsyncThunk(
  "referrers/phone",
  async (phoneNumber, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_URL}/${phoneNumber}`);
      if (res?.data?.error) return rejectWithValue(res?.data?.error);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const UpdateReferrerCode = createAsyncThunk(
  "referrers/updateCode",
  async ({ id, newCode }: { id: string; newCode: string }, { rejectWithValue }) => {
    try {
      const res = await axios.patch(`${API_URL}/${id}/code`, { newCode });
      if (res?.data?.error) return rejectWithValue(res?.data?.error);
      toast.success("Referrer code updated successfully!");
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const GetReferrrerbyCode = createAsyncThunk(
  "referrers/code",
  async (code, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_URL}/code/${code}`);
      if (res?.data?.error) return rejectWithValue(res?.data?.error);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);


export const GetReferrerById = createAsyncThunk(
  "referrers/getById",
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_URL}/${id}`);
      if (res?.data?.error) return rejectWithValue(res?.data?.error);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);